import { Component, NgZone, OnInit } from "@angular/core";
import { GeneralService } from "../app/services/general.service";
import { NavigationEnd, Router } from "@angular/router";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    public generalService: GeneralService,
    private zone: NgZone
  ) {}
  ngOnInit(): void {
    try {
      this.router.events.subscribe({
        next: (event: NavigationEnd) => {
          // console.log(event.url);

          if (event instanceof NavigationEnd) {
            if (this.generalService.userLogin && event.url == "/") {
              this.generalService.showMenu = true;
              this.router.navigate(["admin/index"]);
            }
          }
        },
      });
      window.addEventListener("storage", (event) => {
        if (event.key === "login") {
          if (JSON.parse(localStorage.getItem("login")) == false) {
            this.router.navigate([""]);
            //localStorage.removeItem("logout");
          } else this.router.navigate(["admin/index"]);
        }
      });
    } catch (e) {
      console.log(e);
    }
  }
  title = "Admin";
  isLogin() {
    return JSON.parse(localStorage.getItem("login"));
  }
}
